<template>
    <div class="row deed-owner-details-content">
        <div class="col-12">
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-right_type"
                            name="right_type"
                            label="name"
                            v-model.trim="form.occupation_right_type_id"
                            :options="right_types"
                            v-validate="rulesField('occupation_right_type_id')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('right_type', vScope)}]"
                            :error="fnFirstError('right_type', vScope)">
                            {{ $t(`${modelTranslateID}.right_type`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-term_right_type"
                            name="term_right_type"
                            label="name"
                            v-model.trim="form.occupation_term_right_type_id"
                            :options="term_right_types"
                            @selected="onSelectedTermRightType"
                            v-validate="rulesField('occupation_term_right_type_id')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('term_right_type', vScope)}]"
                            :error="fnFirstError('term_right_type', vScope)">
                            {{ $t(`${modelTranslateID}.term_right_type`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-application_at"
                            name="application_at"
                            v-model.trim="form.application_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            @input="onChangeApplicantAt"
                            v-validate="rulesField('application_at')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('application_at', vScope) }]"
                            :error="fnFirstError('application_at', vScope)">
                            {{ $t(`${modelTranslateID}.application_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-expiry_at"
                            name="expiry_at"
                            v-model.trim="form.expiry_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="rulesField('expiry_at', {dateAfter: [form.application_at, true, $t(`${modelTranslateID}.application_at`)]})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('expiry_at', vScope) }]"
                            :error="fnFirstError('expiry_at', vScope)">
                            {{ $t(`${modelTranslateID}.expiry_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>

                <div class="col-12 col-sm-4">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-certificate_number"
                            name="certificate_number"
                            v-model.trim="form.certificate_number"
                            v-validate="rulesField('certificate_number')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('certificate_number', vScope) }]"
                            :error="fnFirstError('certificate_number', vScope)">
                            {{ $t(`${modelTranslateID}.certificate_number`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm-4">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-process_number"
                            name="process_number"
                            v-model.trim="form.process_number"
                            v-validate="rulesField('process_number')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('process_number', vScope) }]"
                            :error="fnFirstError('process_number', vScope)">
                            {{ $t(`${modelTranslateID}.process_number`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm-4">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-license_number"
                            name="license_number"
                            v-model.trim="form.license_number"
                            v-validate="rulesField('license_number')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('license_number', vScope) }]"
                            :error="fnFirstError('license_number', vScope)">
                            {{ $t(`${modelTranslateID}.license_number`) }}
                        </MaterialInput>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-fee"
                            name="fee"
                            type="number"
                            v-model.trim="form.fee"
                            :step="stepPriceDecimalPlaces"
                            v-validate="rulesField('fee', {decimal: priceDecimalPlaces, min_value:0})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('fee', vScope) }]"
                            :error="fnFirstError('fee', vScope)">
                            {{ $t(`${modelTranslateID}.fee`) }}
                            <template #grpAppend>
                                <span class="input-group-text">{{ currency.symbol }}</span>
                            </template>
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-payment_at"
                            name="payment_at"
                            v-model.trim="form.payment_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('payment_at', vScope) }]"
                            :error="fnFirstError('payment_at', vScope)">
                            {{ $t(`${modelTranslateID}.payment_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>
                <div class="col-12 col-sm align-self-center form-group">
                    <div class="form-check city-form-check form-check-inline">
                        <input
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            type="checkbox"
                            id="input-fee_paid"
                            name="fee_paid"
                            v-model.trim="form.fee_paid"
                            :false-value="false"
                            :true-value="true"
                        />
                        <label
                            class="form-check-label h-auto"
                            :for="`input-fee_paid`"
                        >
                            <div class="d-flex flex-column align-items-start">
                                <span> {{ $t(`${modelTranslateID}.fee_paid`) }}</span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="form-group">
                        <MaterialTextarea
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-obs`"
                            :name="`obs`"
                            :rows="3"
                            v-model.trim="form.obs"
                            v-validate="rulesField('obs')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`obs`, vScope) }]"
                            :error="fnFirstError(`obs`, vScope)">
                            {{ $t(`${modelTranslateID}.obs`) }}
                        </MaterialTextarea>
                    </div>
                </div>

                <div class="col-12 col-sm-12">
                    <DeedOwnerFiles
                        v-model="form.files"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";

export default {
    mixins: [
        FormElementMixin
    ],
    components: {
        MaterialDatePicker: () => import(/* webpackChunkName: "datepicker" */ '@/components/form/MaterialDatePicker'),
        DeedOwnerFiles: () => import(/* webpackChunkName: "cemeteries-deedowner-files" */ './DeedOwnerFiles'),
    },
    props: {
        right_types: {
            type: Array,
            default: () => {return [];},
        },
        term_right_types: {
            type: Array,
            default: () => {return [];},
        },
        service_need_types: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        return {
        }
    },
    computed: {
        term_right_type() {
            return this.term_right_types.find(x => x.id == this.form.occupation_term_right_type_id);
        }
    },
    methods: {
        onSelectedTermRightType(item) {
            if(item && item.increment) {
                this.setExpiryAt(item.increment);
            }
        },
        onChangeApplicantAt(val) {
            this.setExpiryAt(this.term_right_type?.increment);
        },
        setExpiryAt(increment) {
            let application_at = this.form.application_at;
            if(application_at && increment) {
                if(increment.toLowerCase() == 'infinity') {
                    this.form.expiry_at = null;
                }else{
                    let parts = increment.split(',').map((info) => info.trim()) ?? [];
                    if(parts.length == 2) {
                        this.form.expiry_at = moment(application_at).add(parts[0], parts[1]).format(this.dateFormat);
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>